import Helmet from "react-helmet";

const RobotsNoindex = () => {
  return (
    <Helmet>
      <meta name="robots" content="noindex" />
    </Helmet>
  );
};

export default RobotsNoindex;
